import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../../../shared/validators/custom-validators';
import {PatientModel} from '../models/patient.model';

export class PatientFormFactory {
  static createRegisterForm(fb: FormBuilder): FormGroup {
    return fb.group({
        email: ["", [Validators.required, Validators.email]],
        password: ["", [Validators.required, Validators.minLength(8)]],
        passwordRepeat: ["", [Validators.required, Validators.minLength(8)]],
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        sex: ["", Validators.required],
        dateOfBirth: ["", [Validators.required, CustomValidators.dateOfBirth]],
        street: ["", Validators.required],
        city: ["", Validators.required],
        zipCode: ["", [Validators.required, CustomValidators.integer]],
        countryCode: ["CH", [Validators.required, CustomValidators.countryCode]],
        phone: ["", CustomValidators.isoE164],
        mobile: ["", CustomValidators.isoE164],
        language: ["", Validators.required],
      },
      {validators: [CustomValidators.passwordMatch, CustomValidators.phoneRequired]})
  }

  static addPatientForm(fb: FormBuilder): FormGroup {
    return fb.group({
        email: ["", [Validators.required, Validators.email]],
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        sex: ["", Validators.required],
        dateOfBirth: ["", [Validators.required, CustomValidators.dateOfBirth]],
        street: ["", Validators.required],
        city: ["", Validators.required],
        zipCode: [0, [Validators.required, CustomValidators.integer]],
        countryCode: ["CH", [CustomValidators.countryCode]],
        phone: ["", CustomValidators.isoE164],
        mobile: ["", CustomValidators.isoE164],
        language: ["", Validators.required],
      },
      {validators: [CustomValidators.phoneRequired]});
  }

  static createPatientForm(fb: FormBuilder, patientModel: PatientModel): FormGroup {
    return fb.group({
        patientId: [patientModel.patientId],
        firstName: [patientModel.firstName, Validators.required],
        lastName: [patientModel.lastName, Validators.required],
        sex: [patientModel.sex, Validators.required],
        dateOfBirth: [patientModel.dateOfBirth, [Validators.required, CustomValidators.dateOfBirth]],
        street: [patientModel.street, Validators.required],
        city: [patientModel.city, Validators.required],
        zipCode: [patientModel.zipCode, [Validators.required, CustomValidators.integer]],
        countryCode: [patientModel.countryCode, [Validators.required, CustomValidators.countryCode]],
        phone: [patientModel.phone, CustomValidators.isoE164],
        mobile: [patientModel.mobile, CustomValidators.isoE164],
        language: [patientModel.language, Validators.required],
      },
      {validators: [CustomValidators.phoneRequired]});
  }
}
